@if (currentSubscription$ | async; as subscription) {
  <article class="user-subscription-card">
    <h1>{{ subscription.subscriptionPlan.name }}</h1>
    <p>
      Période :
      <span>
        {{ subscription.subscriptionPlan.duration | subscriptionPlanDuration }}
      </span>
    </p>
    <p>
      Date de renouvellement :
      <span>
        {{ subscription.endDate | date: 'dd/MM/yyyy' }}
      </span>
    </p>
    <div>
      <button
        button
        type="button"
        (click)="openSubscriptionDialog(subscription)"
      >
        GÉRER MON ABONNEMENT
      </button>
    </div>
  </article>
}
